/* eslint-disable react/jsx-props-no-spreading */
import {
    useState,
    useCallback,
    useMemo,
} from 'react'

import useEnumValues from 'app/hooks/useEnumValues'
import {
    dayPassedToRange,
} from 'app/utils/date'
import useGetSensorDataForContainer from 'app/hooks/useGetSensorData/useGetSensorDataForContainer'
import {
    getLoggerPositionsConfig,
} from 'app/utils/optionsLoggers'
import {
    LoggerType, LoggerPosition,
} from 'app/enums/label.enums'
import {
    ConfigLogger,
} from 'app/Apps/Loggers/Loggers.types'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import ContainerTemperatureChart from './ContainerTemperatureChart'

type Props = {
    defaultAmbientLoggerType: LoggerType,
    defaultInternalLoggerType: LoggerType,
    serialNumber: string,
}

const ContainerTemperatureChartContainer = ({
    serialNumber,
    defaultAmbientLoggerType,
    defaultInternalLoggerType,
}: Props) => {
    const Routes = useContainerManagementRoutes()

    const getAllowedValuesLoggerType = useEnumValues()(LoggerType)

    const [
        timeRange,
        setRange,
    ] = useState(dayPassedToRange(7))

    const [
        isDateRange,
        setDateRange,
    ] = useState(false)

    const containerLoggerTypes: ConfigLogger = useMemo(() => {
        return {
            title: 'Logger Types',
            name: 'loggerTypes',
            options: Array.from(new Set([
                defaultInternalLoggerType,
                defaultAmbientLoggerType,
            ])).map((type) => {
                return {
                    value: type,
                    label: getAllowedValuesLoggerType[type],
                }
            }),
        }
    }, [
        defaultAmbientLoggerType,
        defaultInternalLoggerType,
        getAllowedValuesLoggerType,
    ])

    const containerLoggerPositions = useMemo(() => {
        return getLoggerPositionsConfig({
            positions: [
                LoggerPosition.INTERNAL,
                LoggerPosition.AMBIENT,
            ],
        })
    }, [])

    const {
        sensorData,
    } = useGetSensorDataForContainer({
        serialNumber,
        from: timeRange.from,
        to: timeRange.to,
        configLoggers: [
            containerLoggerTypes,
            containerLoggerPositions,
        ],
        isDateRange,
    })

    const onFullScreen = useCallback((e) => {
        e.preventDefault()
        Routes.Containers.SensorData.navigate({
            params: {
                key: serialNumber,
            },
        })
    }, [
        Routes.Containers.SensorData,
        serialNumber,
    ])

    return (
        <ContainerTemperatureChart
            {...sensorData}
            setRange={setRange}
            timeRange={timeRange}
            onFullScreen={onFullScreen}
            isDateRange={isDateRange}
            setDateRange={setDateRange}
        />
    )
}

export default ContainerTemperatureChartContainer
